/**
 * @module experience/line-rep-actions
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const LINE_REP_ACTIONS_COMPONENTS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  CANCELLED: 'CANCELLED',
  OVERRIDE: 'OVERRIDE',
  WARRANTY: 'WARRANTY',
};
